// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3go_Z","alert":"SettungsInbox_alert__o_FpW"};